import { hubButtonStyle } from '@arc/frontend/ui-buttons';
import { LinkNavAction } from './nav-action';
export function LinkButton({
  color,
  variant,
  size,
  disabled,
  ...linkProps
}) {
  const {
    to,
    ...rest
  } = linkProps;
  return <LinkNavAction to={disabled ? undefined : to} {...rest} data-disabled={disabled} css={[hubButtonStyle({
    color,
    variant,
    size
  }), "display:flex;align-items:center;justify-content:center;" + (process.env.NODE_ENV === "production" ? "" : ";label:LinkButton;")]} />;
}